import React from "react";
import { useTranslation } from "react-i18next";
import { NumericFormat } from "react-number-format";

const TutoringScheduleCard = ({ items }) => {
  const { t } = useTranslation();

  return (
    <div className="-mx-px grid grid-cols-1 sm:grid-cols-2 sm:mx-0 lg:grid-cols-3 gap-4">
      {items.map((item) => {
        const currentTime = new Date().getTime();
        const scheduledTime = new Date(item.scheduledAt).getTime();
        const remainingHours = Math.max(
          0,
          Math.ceil((scheduledTime - currentTime) / (1000 * 60 * 60))
        );
        let progressBarWidth = Math.min(
          100,
          Math.max(0, ((72 - remainingHours) / 72) * 100)
        );

        if (progressBarWidth === 0) {
          progressBarWidth = 5;
        }

        return (
          <a
            key={item.id}
            href={`/tutoring/detail/${item.program.id}`}
            className="flex border border-gray-200 rounded-lg p-4"
          >
            <div className="flex justify-between flex-col flex-auto gap-4 overflow-hidden">
              <div className="flex flex-col gap-3">
                {item.imageUrl ? (
                  <div className="relative rounded-md w-full h-auto aspect-video overflow-hidden">
                    <img
                      className="absolute object-contain w-full h-full z-10"
                      src={item.imageUrl}
                      alt="Banner"
                      loading="lazy"
                    />
                    <div
                      className="absolute w-full h-full bg-fill blur-[50px] brightness-90 mask-gradient"
                      style={{
                        backgroundImage: `url('${item.imageUrl}')`,
                      }}
                    ></div>
                  </div>
                ) : (
                  <div className="rounded-md w-full h-auto aspect-video text-center overflow-hidden bg-gray-200 text-sm text-gray-500 flex flex-col justify-center">
                    {t("No Image")}
                  </div>
                )}

                <div>
                  <h3 className="text-sm font-bold text-gray-900 text-center line-clamp-2">
                    {item.program.title}
                  </h3>
                </div>
              </div>
              <div className="flex justify-center items-center overflow-hidden">
                <NumericFormat
                  className="text-sm text-gray-900 text-center"
                  displayType={"text"}
                  value={item.program.price}
                  thousandSeparator={"."}
                  decimalSeparator={","}
                  prefix={"Rp "}
                />
              </div>
              <div className="bg-red-400 rounded-xl shadow-sm overflow-hidden">
                <div className="relative p-0.5 flex items-center justify-center">
                  <div
                    className="absolute top-0 bottom-0 left-0 bg-red-600"
                    style={{ width: `${progressBarWidth}%` }}
                  ></div>
                  <div className="relative text-white text-center font-medium text-xs">
                    {t("Ending Soon")}
                  </div>
                </div>
              </div>
            </div>
          </a>
        );
      })}
    </div>
  );
};

export default TutoringScheduleCard;
